import { render, staticRenderFns } from "./event-card.vue?vue&type=template&id=30621317&"
import script from "./event-card.vue?vue&type=script&lang=js&"
export * from "./event-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30621317')) {
      api.createRecord('30621317', component.options)
    } else {
      api.reload('30621317', component.options)
    }
    module.hot.accept("./event-card.vue?vue&type=template&id=30621317&", function () {
      api.rerender('30621317', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/event-listing/components/event-card.vue"
export default component.exports